import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import BreadCrumbs from 'components/BreadCrumbs';
import Loader from 'components/Loader';
import LoaderBar from 'components/LoaderBar';
import DashboardContainer from 'components/DashboardContainer';
import ClientAdminsTable from './ClientAdminsTable';
import ClientDetails from './ClientDetails';
import ClientDetailsActions from './ClientDetailsActions';
import { clientByIdSelector, getClinetById } from 'redux/slices/client';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ClientCompaniesTable from './ClientCompaniesTable';

const ClientDetail = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const { data: client, isLoading } = useSelector((state) =>
    clientByIdSelector(state, id)
  );

  useEffect(() => {
    dispatch(getClinetById(id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return !!client ? (
    <>
      <LoaderBar isVisible={isLoading} />
      <BreadCrumbs screen="client" />
      <DashboardContainer
        header={client?.name}
        rightContent={<ClientDetailsActions />}
      >
        <ClientDetails client={client} />
        <ClientAdminsTable
          data={client.admins?.data}
          pagination={client.admins?.meta?.pagination}
        />
        <ClientCompaniesTable
          data={client.companies?.data}
          pagination={client.companies?.meta?.pagination}
        />
      </DashboardContainer>
    </>
  ) : (
    <Loader />
  );
};

export default ClientDetail;
